<template>
  <span>Failed</span>
</template>

<script>
export default {
  name: "failed"
};
</script>
